import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxtApp) => {
    const cookieConsent = useCookie('visuado-cookie-consent')

    const withdrawConsent = () => {
        cookieConsent.value = null
    }

    return {
        provide: {
            withdrawConsent
        }
    }
})
